var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneLabmanagement48 = function SvgAIconDualtoneLabmanagement48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9792 9.94969C35.3403 8.58862 35.3403 6.38188 33.9792 5.02081C32.6181 3.65973 30.4114 3.65973 29.0503 5.02081L21.6615 12.4116C21.0215 13.0511 20.6064 13.881 20.4785 14.7766L20.1785 16.8465L18.7045 18.3245C18.4344 18.5973 18.4344 19.0367 18.7045 19.3095L19.6905 20.2955C19.9633 20.5655 20.4027 20.5655 20.6755 20.2955L22.1504 18.8175L24.2204 18.5175C25.116 18.3896 25.9459 17.9744 26.5854 17.3345L33.9792 9.94969Z",
    fill: "#DCECFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1094 5.021L33.9782 13.8898L25.1094 5.021Z",
    fill: "#DCECFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 5.021L33.9782 13.8898",
    stroke: "#DCECFA",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 33.1367V45C5 46.1046 5.89543 47 7 47H45C46.1046 47 47 46.1046 47 45V33.1367C47 31.4043 45.6569 30 44 30H23H11H8C6.34315 30 5 31.4043 5 33.1367Z",
    fill: "#DCECFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9792 6.94969C31.3403 5.58862 31.3403 3.38188 29.9792 2.02081C28.6181 0.659731 26.4114 0.659731 25.0503 2.02081L17.6615 9.41164C17.0215 10.0511 16.6064 10.881 16.4785 11.7766L16.1785 13.8465L14.7045 15.3245C14.4344 15.5973 14.4344 16.0367 14.7045 16.3095L15.6905 17.2955C15.9633 17.5655 16.4027 17.5655 16.6755 17.2955L18.1504 15.8175L20.2204 15.5175C21.116 15.3896 21.9459 14.9744 22.5854 14.3345L29.9792 6.94969Z",
    stroke: "#2C5A82",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 2.021L29.9782 10.8898",
    stroke: "#2C5A82",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5L23.5 8.5",
    stroke: "#2C5A82",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0005 18.6494L11.6586 21.3284C11.3696 21.906 11.4828 22.6037 11.9396 23.0603V23.0603C12.2209 23.3418 12.6026 23.5 13.0005 23.5C13.3985 23.5 13.7802 23.3418 14.0615 23.0603V23.0603C14.5183 22.6037 14.6315 21.906 14.3425 21.3284L13.0005 18.6494Z",
    stroke: "#2C5A82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31L7 32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 31L11.9492 32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8994 31V32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8506 31V32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 31L26.8008 32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 31L31.75 32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6992 31V32.5",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36.25L7 37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 36.25L11.9492 37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8994 36.25V37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8506 36.25V37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 36.25L26.8008 37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 36.25L31.75 37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6992 36.25V37.75",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41.5L7 43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 41.5L11.9492 43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8994 41.5V43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8506 41.5V43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8008 41.5L26.8008 43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 41.5L31.75 43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6992 41.5V43",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 42.7594V29.5C1 27.8431 2.34315 26.5 4 26.5H7M43 42.7594V29.5C43 27.8431 41.6569 26.5 40 26.5H19",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgAIconDualtoneLabmanagement48 as ReactComponent };
export default "data:image/svg+xml;base64,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";